'use strict'

import React from 'react';

import AreaForm from '../components/AreaForm.jsx';
import riskResponseLabel from './riskResponseLabel.js';

import Translations from '../../app/utils/translations.js';
import FormattedContent from '../components/FormattedContent.jsx';

let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
]);

import formDefinition from './formDefinition.js';

export class RiskStatement extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).general.statement;
    return (
      <div>
        <div style={{paddingTop: 5, fontStyle:"italic", minHeight:"30pt"}}>
          {labels.if} <span style={{fontStyle:"normal"}}>"{this.props.cause}"</span> ({labels.cause})
          <span>, </span>
          {this.props.expanded ? (
            <div style={{paddingTop: 20}}/>
          ) : null}
          {labels.thereIsA} {labels.riskTypeOptions[this.props.type]} {labels.that} <span style={{fontStyle:"normal"}}>"{this.props.event}"</span> ({labels.event})
          <span>, </span>
          {this.props.expanded ? (
            <div style={{paddingTop: 20}}/>
          ) : null}
          {labels.whichWouldResultIn} <span style={{fontStyle:"normal"}}>"{this.props.effect}"</span> ({labels.effect}).
        </div>
      </div>
    );
  }
}

class IdentifySummary extends React.Component {
  render() {
    return (
      <div>
        <div style={{height: "10pt"}}>
          <b>{this.props.no!==undefined ? this.props.no+". " : ""}{this.props.title}</b>
        </div>
        <RiskStatement {...this.props}/>
      </div>
    );
  }
}

class ImplementSummary extends React.Component {
  render() {
    return (
      <div>
        <IdentifySummary {...this.props}/>
        <div style={{paddingTop:10}}>
          <div style={{fontWeight:"bold"}}>Plan</div>
          <div><FormattedContent value={this.props.action}/> ({riskResponseLabel(this.props.response,this.props.language)})</div>
        </div>
      </div>
    );
  }
}

export default class RiskForm extends React.Component {
  constructor(props) {
    super(props);
    this.state={item:props.item};
  }

  componentWillReceiveProps(props) {
    this.setState({modified:undefined, item:props.item});
  }

  handleFieldChange(fieldName) {
    return (event)=>{
      this.setState({
        item:Object.assign({},this.state.item,{[fieldName]:event.target.value}),
        modified:true
      });
    };
  }

  submitForm(event) {
    event.preventDefault();
    var formValues={};
    for (var i=0; i<event.target.elements.length; i++) {
      var value=event.target.elements[i].value;
      if (value.trim().length===0) {
        value=undefined;
      }
      formValues[event.target.elements[i].name]=value;
    }
    formValues.cancel=undefined;
    formValues.save=undefined;
    this.props.onCommand({type:"update", item: formValues});
  }

  update(item) {
    console.log("Update");
    this.props.onCommand({type:"update", item: item});
  }

  cancelForm(event) {
    event.preventDefault();
    this.props.onCommand({type:"cancel"});
  }

  summary(tab,details) {
    var content=undefined;
    let value=details.values;
    let oldValues=details.oldValues;
    switch (tab) {
      case "identify":
      case "assess":
      case "plan":
        content=<IdentifySummary {...this.state.item} language={this.props.language}/>
        break;
      case "implement":
        content=<ImplementSummary {...this.state.item} language={this.props.language}/>
        break;
    }
    return content!==undefined ? (
      <div style={{fontFamily:"Arial", fontSize:"10pt", padding:10}}>
        {content}
      </div>
    ) : null;
  }

  trialDefinition(definition,useTrial) {
    let includeField=(field)=>
      field.name!=="assessment" && field.name!=="impact" && field.name!=="probability"
      ? true
      : field.name==="assessment" && useTrial===true
        ? true
        : useTrial!==true && field.name!=="assessment"
          ? true
          : false;
    let updateField=(field)=>includeField(field) ? field : undefined;
    let updateArea=(area)=>
      area.name==="assess"
        ?  Object.assign({},area,{
              fields: area.fields.filter(field=>updateField(field))
            })
        : area;
    return definition.map(area=>updateArea(area))
  }


  render() {
    var item=(this.state.item!==undefined) ? Object.assign({},this.state.item) : {};
    if (this.props.trial) {
      if (item.assessment===undefined) {
        item.assessment={
          no: item.no,
          hideCategories: item.inherentRisk===undefined && item.impact===undefined && item.probability===undefined,
          category: item.inherentRisk===undefined ? "inherent" : "residual",
          inherent: item.inherentRisk!==undefined ? item.inherentRisk : {
            impact: item.impact,
            probability: item.probability
          },
          residual: {
            impact: item.impact,
            probability: item.probability
          }
        };
      }
      if (item.no!==undefined && item.assessment!==undefined && item.no!==item.assessment.no) {
        //Ensure no is set on assessment after save of new item
        item.assessment.no=item.no;
      }
      item.assessment.hide=(item.status==="Closed");
    }
    var closedDate=item.status==="Closed" && item.closed!==undefined ? ["Closed at "+item.closed.substring(0,10)] : undefined;
    var areas=translations.createTranslatedForm(this.trialDefinition(formDefinition,this.props.trial),this.props.language,this.props.variant);
    return (
      <div>
        <div style={{display:"flex", justifyContent:"center"}}>
          <div style={{flexBasis:"100%", maxWidth:1016, minWidth:250}}>
            <AreaForm
              {...this.props}
              areas={areas}
              display="tab"
              item={Object.assign({},item,{
                      _progress:item.id!==undefined ? "implement" : "identify"
                    })}
              onUpdate={this.update.bind(this)}
              onCancel={this.cancelForm.bind(this)}
              summary={this.summary.bind(this)}
              modified={this.state.modified}
              updatedItem={item}
              handleFieldChange={this.handleFieldChange.bind(this)}
              label="Risk"
            />
          </div>
        </div>
        <div style={{display:"none", paddingTop: 30, paddingBottom:80, clear:"left", float:"none"}}>
          <input className="cancel" type="button" onClick={this.cancelForm.bind(this)} name="cancel" value="Cancel"/>
          <input className="save" style={{marginLeft: 15}} type="submit" name="save" value={item.id===undefined ? "Add risk" : "Update risk"}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/risk/RiskForm.jsx